<script setup lang="ts">

const { isReversed = false } = defineProps<{ isReversed?: boolean}>();

</script>

<template>

    <div class="flex items-center flex-col md:flex-row"
         :class="{ 'md:!flex-row-reverse': isReversed}">

        <div class="basis-full md:basis-2/5 px-4 flex justify-center">
            <div class="absolute top-12 md:top-16 lg:top-24 bottom-12 md:bottom-16 lg:bottom-24 w-full md:bg-[#a0b1e4] 
                        rounded-sm rounded-bl-[40%] rounded-tr-[20%] lg:rounded-bl-[60%] lgrounded-tr-[30%]">
            </div>
            <slot name="image"></slot>
        </div>

        <div class="basis-full md:basis-3/5 text-left pr-8 md:pr-16 pl-8"
             :class="{ '!pl-8 pr-8 md:pr-16': isReversed}">
            <h1 class="text-4xl font-semibold mt-6 mb-3">
                <slot name="headline"></slot>
            </h1>
            <slot></slot>
        </div>
    
    </div>

</template>